<template>
  <div class="validation-code-container">
    <div class="body-container">
      <div class="title-container">Portal de validación de Identidad</div>
      <div class="input-container">
        <p class="instruction-text">
          Para comenzar con tu validación de identidad, debes ingresar tu código de validación
        </p>
        <div class="input-wrapper">
          <label for="code" class="label-get-code">
            <label>
              Código de Validación
              <vue-feather class="alert-icon" type="alert-circle" size="16"></vue-feather>
              <p v-if="validationCodeWithError" class="alert-text">
                Tu código de validación no es correcto. Vuelve a intentarlo o solicita uno nuevo.
              </p>
            </label>
          </label>
          <input
            class="input input-get-code"
            id="code"
            type="text"
            placeholder="  A12345"
            required
            v-model="validationCode"
          />
          <a v-if="!isPartialPortal" href="#" class="help-link">¿Cómo obtengo un código de validación?</a>
        </div>
        <PdsButton id="check-code" label="Validar código" @click="checkCode()" />
      </div>
      <div class="information-container ">
        <p class="information-title">
          Conoce la política de
          <span v-if="company === 'cuprum'">Cuprum AFP</span>
          <span v-else>Principal</span>
          sobre datos personales
        </p>
        <p class="information-text">
          Según la ley No. 19.628, te informamos que los datos personales que vas a ingresar en este flujo quedan en nuestras bases de datos y los utilizaremos con el propósito de validar tu identidad para ejecutar transacciones.
        </p>
        <br/>
        <p class="information-text">
          Asimismo, te informaremos que el tratamiento de datos siempre se regirá por los principios y las bases de legitimidad establecidas en la ley No. 19.628.
          Para mayor detalle, consulta las políticas detalladas en nuestro sitio web.
          <a v-if="!isPartialPortal" href="#">¿Cuáles son los fines previsionales?</a>
        </p>  
      </div>
    </div>
  </div>
</template>

<script>
import VueFeather from "vue-feather";
import PdsButton from "@vue-pds/button";

const eventName = "validationCodeResponse";

export default {
  name: "ValidationCode",
  components: {
    VueFeather,
    PdsButton
  },
  props: {
    company: { type: String, default: "cuprum" },
    dummyMode: { type: Boolean, default: false },
    validationCodeWithError: { type: Boolean, default: false },
    isPartialPortal: { type: Boolean, default: false }
  },
  data() {
    return {
      validationCode: ""
    };
  },
  methods: {
    checkCode() {
      const validationCode = this.validationCode;
      this.$emit(eventName, { validationCode });
    }
  }
};
</script>
<style scoped src="@pds/button/button.min.css"></style>
<style scoped>
.validation-code-container {
  align-self: center;
  font-family: "FS Elliot Web Regular", sans-serif;
  margin: auto;
}
.body-container {
  text-align: center;
  align-items: center;
  padding-bottom: 60px;
}
.title-container {
  width: 100%;
  padding-top: 60px;
  font-size: 50px;
  line-height: 66px;
  font-family: "FS Elliot Web Bold", sans-serif;
  align-items: center;
  text-align: center;
  color: #000000;
}
.input-container {
  margin: auto;
  max-width: 42%;
  padding-top: 30px;
}
.instruction-text {
  height: 62px;
  font-size: 24px;
  line-height: 31px;
  text-align: left;
}
.label-get-code {
  color: #333333;
  font-size: 16px;
  line-height: 21px;
  text-align: left;
  width: 100%;
  border-top: 42px;
  font-family: "FS Elliot Web Bold", sans-serif;
}
.input-get-code {
  height: 40px;
  width: 100%;
  color: #4a4a4a;
  font-size: 16px;
  letter-spacing: 0;
  line-height: 18px;
  padding: 0%;
  border: 1px solid #333333;
  box-sizing: border-box;
  border-radius: 6px;
}
.alert-icon {
  color: #04508a;
}
.input-wrapper {
  width: 100%;
  text-align: left;
  padding-top: 30px;
}
.help-link {
  padding-top: 6px;
  width: 100%;
  text-align: left;
  font-size: 14px;
  line-height: 18px;
  height: 18px;
}
.pds-button-primary {
  font-size: 16px;
  line-height: 21px;
  text-align: center;
  margin-top: 60px;
}
.information-container {
  max-width: 62%;
  text-align: left;
  margin: auto;
  padding-top: 60px;
}
.information-title {
  font-size: 14px;
  line-height: 18px;
  font-weight: bold;
  color: #333333;
  margin-bottom: 0px;
}
.information-text {
  margin-top: 7px;
  font-size: 14px;
  line-height: 18px;
  color: #333333;
}
.alert-text {
  font-size: 16px;
  line-height: 21px;
  color: #c00000;
  margin-top: 8px;
  margin-bottom: 8px;
}

/* Middle Screen Settings */
@media only screen and (min-width: 700px) and (max-width: 1150px) {
  .title-container {
    font-size: 40px;
  }
  .instruction-text {
    font-size: 22px;
  }
  .input-container {
    max-width: 62%;
  }
  .information-container {
    max-width: 70%;
  }
}
@media only screen and (max-width: 700px) {
  .title-container {
    font-size: 30px;
    line-height: 46px;
    padding-top: 37px;
  }
  .input-container {
    max-width: 92%;
    padding-top: 0%;
  }
  .instruction-text {
    font-size: 16px;
    line-height: 21px;
    min-width: 100%;
    margin: auto;
    text-align: center;
  }
  .input-wrapper {
    padding-top: 17px;
  }
  .pds-button-primary {
    font-size: 16px;
    line-height: 21px;
    text-align: center;
    margin-top: 35px;
  }
  .information-container {
    max-width: 92%;
    text-align: center;
    padding-top: 57px;
    font-size: 14px;
    line-height: 18px;
  }
  .body-container {
    padding-bottom: 34px;
  }
}
</style>
